const getSvgEllipseLength = el => 2 * Math.PI * Math.sqrt(((parseFloat(el.getAttribute('rx')) ** 2) + (parseFloat(el.getAttribute('ry')) ** 2)) / 2)

export default getSvgEllipseLength
